import { Decimal } from 'decimal.js';

import { type SuggestedOffersResponse } from '../aliases';

export function formatSuggestedOffersResponse(
  suggestedOffersResponse?: SuggestedOffersResponse
) {
  return suggestedOffersResponse?.offers?.map((suggestion) => {
    return {
      price: new Decimal(suggestion.rounded_amount).toFixed(2),
      percentageDiscount: new Decimal(suggestion.percentage)
        .times(100)
        .toNumber(),
    };
  });
}
